import React, { useEffect, useState } from "react";
import arrow from "../images/icon-arrow-black.svg";
import IcePhone1 from "../images/maestro-image.png";
import IcePhone2 from "../images/maestro-image.png";
import IcePhone3 from "../images/maestro-image.png";
import IcePhone4 from "../images/maestro-image.png";

const datas = [
  {
    id: 1,
    title: "Name Your Brand",
    text:
      "You have probably the perfect brand and domain name in place - just type it in and start your Maestro experience."
  },
  {
    id: 2,
    title: "Choose Your Design Theme",
    text:
      "The layout, the colors, the fonts, the menu, you name it - you adjust and choose your favorite theme in minutes with Maestro."
  },
  {
    id: 3,
    title: "Select License & Payment Methods",
    text:
      "Tick the license and payment methods that you want for your market and territory."
  },
  {
    id: 4,
    title: "Publish and Go Live",
    text:
      "We do a quality check and when everything is signed off, you can go live with your new brand. Ready to go?<br/><br/>Contact us at: <a href='mailto:hello@stech.com'>hello@stech.com</a>"
  }
];

const HeroBanner = () => {
  const [currentCount, setCount] = useState(1);
  const timer = () => setCount(currentCount + 1);
  useEffect(() => {
    if (currentCount === 5) {
      setCount(1);
    }
    const id = setInterval(timer, 5000);
    return () => clearInterval(id);
  }, [currentCount]);

  const image = () => {
    switch (currentCount) {
      case 1:
        return IcePhone1;
      case 2:
        return IcePhone2;
      case 3:
        return IcePhone3;
      case 4:
        return IcePhone4;
      default:
        return IcePhone4;
    }
  };

  return (
    <header className="clearfix fadeInUp">
      <div className="container relative clearfix">
        <div className="text herobanner clearfix">
          <h1 className="fadeInUp">
            Go Live with <strong>Maestro</strong> in{" "}
            <span>Four Simple Steps</span>
          </h1>
          {datas.map(data => (
            <div
              className={
                currentCount === data.id
                  ? "hero active fadeInUp"
                  : "hero fadeInUp"
              }
              key={data.id}
              onClick={() => setCount(data.id) && image(data.id)}
            >
              <span>{data.id}</span>
              <div className="content">
                <h2>{data.title}</h2>
                <p dangerouslySetInnerHTML={{ __html: data.text }} />
              </div>
            </div>
          ))}
        </div>
        <div className="screen clearfix">
          <div className="desktop">
            <img src={image()} alt="Maestro" />
          </div>
        </div>
        <div className="what clearfix">
          <span>
            <img src={arrow} alt=" See What We Do" />
          </span>
          See What We Do
        </div>
      </div>
    </header>
  );
};

export default HeroBanner;
